// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"9360d542","463":"b79de7c5","583":"6d04bc82","920":"92365d6e"}[chunkId] + ".chunk.js";
};